import { render, staticRenderFns } from "./step04.vue?vue&type=template&id=a32d388e&scoped=true&"
import script from "./step04.vue?vue&type=script&lang=js&"
export * from "./step04.vue?vue&type=script&lang=js&"
import style0 from "./step04.vue?vue&type=style&index=0&id=a32d388e&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32d388e",
  null
  
)

export default component.exports